import React, { useEffect, useState, useContext } from "react";
import "./VoyahTaishanExteriorInterior.css";

import exterior1 from "../../../../assets/images/voyahtaishan/exterior1.jpg";
import exterior2 from "../../../../assets/images/voyahtaishan/exterior2.jpg";
import exterior3 from "../../../../assets/images/voyahtaishan/exterior3.jpg";
import exterior4 from "../../../../assets/images/voyahtaishan/exterior4.jpg";
import exterior5 from "../../../../assets/images/voyahtaishan/exterior5.jpg";
import exterior6 from "../../../../assets/images/voyahtaishan/exterior6.jpg";
import exterior7 from "../../../../assets/images/voyahtaishan/exterior7.jpg";

import interior1 from "../../../../assets/images/voyahtaishan/interior1.png";
import interior2 from "../../../../assets/images/voyahtaishan/interior2.png";
import interior3 from "../../../../assets/images/voyahtaishan/interior3.png";
import interior4 from "../../../../assets/images/voyahtaishan/interior4.png";

import accessories1 from "../../../../assets/images/voyahtaishan/ac1.png";
import accessories2 from "../../../../assets/images/voyahtaishan/ac2.png";

import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";

const EXTERIOR_IMAGES = [
  exterior1,
  exterior2,
  exterior3,
  exterior4,
  exterior5,
  exterior6,
  exterior7,
];
const INTERIOR_IMAGES = [interior1, interior2, interior3, interior4];
const ACCESSORIES_IMAGES = [accessories1, accessories2];

const TaishanSlider = ({ title, images }) => {
  const [index, setIndex] = useState(0);

  if (!images || images.length === 0) return null;

  const prev = () =>
    setIndex(index === 0 ? images.length - 1 : index - 1);

  const next = () =>
    setIndex(index === images.length - 1 ? 0 : index + 1);

  return (
    <section dir="ltr" className="vt-gallery-section">
      <h2 className="vt-gallery-title">{title}</h2>
      <span className="vt-gallery-line" />

      <div className="vt-slider">
        <img src={images[index]} alt={title} className="vt-slide-image" />

        <button className="vt-arrow vt-arrow-left" onClick={prev}>
          ‹
        </button>

        <button className="vt-arrow vt-arrow-right" onClick={next}>
          ›
        </button>

        <div className="vt-dots">
          {images.map((_, i) => (
            <span
              key={i}
              className={`vt-dot ${i === index ? "active" : ""}`}
              onClick={() => setIndex(i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

const VoyahTaishanExteriorInterior = () => {
  const { currentLang } = useContext(LanguageContext);

  const [titles, setTitles] = useState({
    exterior_title: "Exterior",
    interior_title: "Interior",
    accessories_title: "Accessories",
  });

  useEffect(() => {
    const loadGalleryText = async () => {
      try {
        const response = await getPageContent("voyahtaishan", currentLang);
        const gallery = response.sections?.gallery;

        if (gallery) {
          setTitles({
            exterior_title: gallery.exterior_title || "Exterior",
            interior_title: gallery.interior_title || "Interior",
            accessories_title: gallery.accessories_title || "Accessories",
          });
        }
      } catch (err) {
        console.error("Failed to load Voyah Taishan gallery text", err);
      }
    };

    loadGalleryText();
  }, [currentLang]);

  return (
    <div className="vt-gallery-wrapper">
      <TaishanSlider title={titles.exterior_title} images={EXTERIOR_IMAGES} />
      <TaishanSlider title={titles.interior_title} images={INTERIOR_IMAGES} />
      <TaishanSlider
        title={titles.accessories_title}
        images={ACCESSORIES_IMAGES}
      />
    </div>
  );
};

export default VoyahTaishanExteriorInterior;
